import { render, staticRenderFns } from "./SupportWidgets.vue?vue&type=template&id=bfb77460&scoped=true"
import script from "./SupportWidgets.vue?vue&type=script&lang=js"
export * from "./SupportWidgets.vue?vue&type=script&lang=js"
import style0 from "./SupportWidgets.vue?vue&type=style&index=0&id=bfb77460&prod&scoped=true&lang=css"
import style1 from "./SupportWidgets.vue?vue&type=style&index=1&id=bfb77460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb77460",
  null
  
)

export default component.exports